/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sreality_Seller_EmployeeInputs */

const cs_sreality_seller_employee = /** @type {(inputs: Sreality_Seller_EmployeeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zaměstnanec této RK (HPP)`)
};

const en_sreality_seller_employee = /** @type {(inputs: Sreality_Seller_EmployeeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Employee of this RK (HPP)`)
};

/**
* | output |
* | --- |
* | "Employee of this RK (HPP)" |
*
* @param {Sreality_Seller_EmployeeInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const sreality_seller_employee = /** @type {((inputs?: Sreality_Seller_EmployeeInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sreality_Seller_EmployeeInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_sreality_seller_employee(inputs)
	return cs_sreality_seller_employee(inputs)
});